import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import DokterService from "@/services/SoapRanapDokter";
// import PerawatService from "@/services/SoaRanapPerawat";
import { SoapRanapResponseItem } from "@/types/soap";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "soap-ranap-store"
})
class SoapRanapStore extends VuexModule {
  loadingSoapDokter = false;
  loadingList = false;
  soapDokterList: SoapRanapResponseItem[] = [];
  soapPerawatList: SoapRanapResponseItem[] = [];
  soap: SoapRanapResponseItem[] = [];

  get soapList(): SoapRanapResponseItem[] {
    return this.soap.sort((a, b) => {
      return (
        new Date(b.examined_at).getTime() - new Date(a.examined_at).getTime()
      );
    });
  }

  @Mutation
  SET_SOAP_DOKTER_LIST(val: SoapRanapResponseItem[]) {
    this.soapDokterList = val;
  }

  @Mutation
  SET_SOAP_PERAWAT_LIST(val: SoapRanapResponseItem[]) {
    this.soapPerawatList = val;
  }

  @Mutation
  SET_SOAP_DOKTER_LOADING(val: boolean) {
    this.loadingSoapDokter = val;
  }

  @Mutation
  SET_SOAP_LIST_LOADING(val: boolean) {
    this.loadingList = val;
  }

  @Mutation
  SET_SOAP(val: SoapRanapResponseItem[]) {
    this.soap = val;
    console.log("set soap");
  }

  @Mutation
  RESET_SOAP_DOKTER_LIST() {
    this.soapDokterList = [];
  }

  @Mutation
  RESET_SOAP_PERAWAT_LIST() {
    this.soapPerawatList = [];
  }

  @Mutation
  RESET_SOAP_LIST() {
    this.soapDokterList = [];
    this.soapPerawatList = [];
    this.soap = [];
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_SOAP_LIST_LOADING(true);
    const soap = await DokterService.getByRegister(registerId).finally(() => {
      this.SET_SOAP_LIST_LOADING(false);
    });

    this.SET_SOAP(soap.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_SOAP_LIST();
  }
}

export default getModule(SoapRanapStore);
